import { reviewsService } from '../services/reviews.service';
import { type PendingReview, ReviewStatus } from '../types';
import { useCatalogueSection, type CatalogueSectionService } from './useCatalogueSection';

const CATALOGUE_REVIEWS_PAGE_SIZE = 5;

const catalogueReviewService: CatalogueSectionService<'reviewId', string, PendingReview> = {
  itemIdName: 'reviewId',
  pageSize: CATALOGUE_REVIEWS_PAGE_SIZE,
  itemsLabel: 'review',
  fetchPage: async (cursor) => await reviewsService.getAllReviews(ReviewStatus.PENDING, CATALOGUE_REVIEWS_PAGE_SIZE, cursor),
  approveItem: async (reviewId, versionId) => await reviewsService.approveReview(reviewId, versionId),
  rejectItem: async (reviewId, versionId) => await reviewsService.declineReview(reviewId, versionId),
  bulkApproveItems: async (infos) => await reviewsService.bulkApproveReviews(infos),
}

export const useCatalogueReviews = () => {
  const { items, approveItem, rejectItem, approveAllItems, loading, pagination } = useCatalogueSection(
    catalogueReviewService
  )

  return {
    reviews: items,
    approveReview: approveItem,
    declineReview: rejectItem,
    bulkApproveReviews: approveAllItems,
    loading,
    pagination
  }
};
